import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "order" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Ticket Order", -1)
const _hoisted_3 = {
  key: 0,
  id: "order-container"
}
const _hoisted_4 = { id: "ticket" }
const _hoisted_5 = { id: "qrcode" }
const _hoisted_6 = {
  key: 0,
  id: "ticket-check-ins"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "price-qantity" }
const _hoisted_10 = {
  key: 1,
  class: "refund message"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { id: "qrcode-message" }, [
  /*#__PURE__*/_createElementVNode("p", null, "This QR code is your tickets for your selected nights. You may print this page out OR have the email and code available on your mobile device at the door. You should share the email and code with all members of your party.")
], -1)
const _hoisted_12 = { id: "order-info" }
const _hoisted_13 = { id: "products" }
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "price-qantity" }
const _hoisted_16 = {
  id: "subtotal",
  class: "total"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "Sub Total:", -1)
const _hoisted_18 = {
  id: "fee",
  class: "total"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", null, "Transaction Fee:", -1)
const _hoisted_20 = {
  id: "order-total",
  class: "total"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Order Total:", -1)
const _hoisted_22 = {
  key: 0,
  id: "refund-total",
  class: "total"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "Refund Total:", -1)
const _hoisted_24 = {
  key: 1,
  id: "partial-refund-total",
  class: "total"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("strong", null, "Refund Total:", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, "Billing Information", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteHeader = _resolveComponent("SiteHeader")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SiteHeader),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (Object.keys(_ctx.order).length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_qrcode_vue, {
                  value: String(_ctx.qrcodeValue),
                  size: 200
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", null, [
                (_ctx.order.status !== 'refund')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.products, (product) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "product",
                          key: product._id
                        }, [
                          (product.checkIns > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(product.name) + ", " + _toDisplayString(_ctx.formatDate(product.eventDate)), 1),
                                _createElementVNode("span", _hoisted_9, [
                                  _createElementVNode("strong", null, "Available: " + _toDisplayString(product.checkIns), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.order.status === 'refund')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "QR code is no longer valid for entry."))
                  : _createCommentVNode("", true),
                _hoisted_11
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", null, [
                _createTextVNode("Order Summary "),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.order.status.toLowerCase().replace('_', '-'))
                }, _toDisplayString(_ctx.order.status.toUpperCase().replace('_', ' ')), 3)
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.products, (product) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "product",
                    key: product._id
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(product.name) + ", " + _toDisplayString(_ctx.formatDate(product.eventDate)), 1),
                    _createElementVNode("span", _hoisted_15, [
                      _createElementVNode("strong", null, _toDisplayString(product.quantity), 1),
                      _createTextVNode(" x $" + _toDisplayString(Number(product.price.$numberDecimal).toFixed(2)), 1)
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createTextVNode(" $" + _toDisplayString(Number(_ctx.order.orderTotal.$numberDecimal).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(" $" + _toDisplayString(Number(_ctx.order.transactionFee.$numberDecimal).toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createTextVNode(" $" + _toDisplayString(Number(Number(_ctx.order.transactionFee.$numberDecimal) + Number(_ctx.order.orderTotal.$numberDecimal)).toFixed(2)), 1)
                ]),
                (_ctx.order.status === 'refund')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createTextVNode(" $" + _toDisplayString(Number(_ctx.order.orderTotal.$numberDecimal).toFixed(2)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.order.status === 'partial_refund')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createTextVNode(" $" + _toDisplayString(_ctx.refundTotal(_ctx.order).toFixed(2)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_26,
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.order.customer.firstName) + " " + _toDisplayString(_ctx.order.customer.lastName), 1),
                _hoisted_27,
                _createTextVNode(" " + _toDisplayString(_ctx.order.customer.address.line1), 1),
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.order.customer.address.line2), 1),
                (_ctx.order.customer.address.line2)
                  ? (_openBlock(), _createElementBlock("br", _hoisted_29))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.order.customer.address.city) + ", " + _toDisplayString(_ctx.order.customer.address.stateOrProvince) + " " + _toDisplayString(_ctx.order.customer.address.postalCode), 1),
                _hoisted_30,
                _createTextVNode(" " + _toDisplayString(_ctx.order.customer.email), 1),
                _hoisted_31,
                _createTextVNode(" " + _toDisplayString(_ctx.order.customer.phone), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}